import CityData from '@type/sorr2025/CityData';
import { ChartConfiguration } from 'chart.js';

type BarChartConfig = {
    data: CityData[];
    backgroundColor: CanvasGradient;
    borderColor: string;
};

const barChartConfig = ({ data, backgroundColor, borderColor }: BarChartConfig): ChartConfiguration => {
    return {
        type: 'bar',
        data: {
            labels: data.map((row) => row.key),
            datasets: [
                {
                    //label: 'Acquisitions by year',
                    data: data.map((row) => row.percentage),
                    borderWidth: 2,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderRadius: 25,
                    barThickness: 54,
                    borderSkipped: false,
                    categoryPercentage: 0.5,
                    barPercentage: 1.0,
                },
            ],
        },
        options: {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    display: false,
                    beginAtZero: true,
                    grid: {
                        display: false,
                    },
                },
                y: {
                    beginAtZero: true,
                    border: {
                        width: 0,
                    },
                    grid: {
                        display: false,
                    },
                    ticks: {
                        display: true,
                        color: '#6E2F25',
                    },
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                datalabels: {
                    color: 'white',
                    anchor: 'end',
                    align: 'left',
                    font: {
                        weight: 'bold',
                    },
                    formatter: function (value) {
                        return `${value}%`;
                    },
                },
            },
        },
    };
};

export default barChartConfig;
